import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const Sidebar = () => {
  const location = useLocation();
  const { integrations, loading } = useAuth();

  // Integration-specific navigation items
  // Icon paths are SVG path data for each icon, or image path for custom icons
  const navigationItems = {
    charges: {
      name: 'Charges',
      href: '/charges',
      icon: '/medical-expenses.png',
      iconType: 'image',
      relatedPaths: ['/files'] // Related paths that should also show as active
    },
    scheduler: {
      name: 'Scheduler',
      href: '/scheduler',
      icon: '/Scheduler.png',
      iconType: 'image',
      relatedPaths: ['/appointments'] // Related paths that should also show as active
    },
    demographics: {
      name: 'Demographics',
      href: '/demographics-dashboard',
      icon: '/demo.png',
      iconType: 'image',
      relatedPaths: ['/demographics'] // Related paths that should also show as active
    },
    pf: {
      name: 'Practice Fusion',
      href: '/pf',
      icon: '/PF_logo.png',
      iconType: 'image',
      relatedPaths: ['/resolution'] // Related paths that should also show as active
    }
  };

  // Build navigation based on available integrations
  const navigation = (integrations || [])
    .filter(integrationType => navigationItems[integrationType])
    .map(integrationType => navigationItems[integrationType]);

  // Show loading or empty state if no integrations
  if (loading || navigation.length === 0) {
    return (
      <div className="sidebar-fixed">
        <div className="flex-1 p-4">
          <nav className="space-y-2">
            {loading && (
              <div className="text-center text-gray-500 text-xs">Loading...</div>
            )}
          </nav>
        </div>
      </div>
    );
  }

  return (
    <div className="sidebar-fixed">
      <div className="flex-1 p-4">
        <nav className="space-y-2">
          {navigation.map((item) => {
            const isActive = location.pathname === item.href ||
              location.pathname.startsWith(item.href + '/') ||
              (item.relatedPaths && item.relatedPaths.some(path =>
                location.pathname === path || location.pathname.startsWith(path + '/')
              ));
            return (
              <Link
                key={item.name}
                to={item.href}
                className={`relative flex flex-col items-center justify-center px-2 py-3 rounded-md transition-all ${
                  isActive
                    ? 'text-blue-700 font-bold'
                    : 'text-gray-700 font-medium hover:bg-gray-50 hover:text-blue-700'
                }`}
              >
                {isActive && (
                  <span className="absolute left-0 top-1/2 -translate-y-1/2 text-blue-600 text-lg font-bold">➤</span>
                )}
                {item.iconType === 'image' ? (
                  <img
                    src={item.icon}
                    alt={item.name}
                    className="w-8 h-8 md:w-10 md:h-10 xl:w-12 xl:h-12 object-contain"
                    style={{ mixBlendMode: 'multiply' }}
                  />
                ) : (
                  <svg
                    className="w-8 h-8 md:w-10 md:h-10 xl:w-12 xl:h-12"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={item.icon} />
                  </svg>
                )}
                <span className="hidden md:block text-[10px] xl:text-xs mt-1 text-center leading-tight">
                  {item.name}
                </span>
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;
